import {forEach, getParent} from "../../../common/js/Helpers";
import {slideToggle, slideUp} from "../../../common/js/slide";

function setQuantityNeedsCalculationMode(e) {
    forEach(getParent(e.target, '.lineitem-container').querySelectorAll('.eventgallery-hide-on-quantity-change'), (elm) => {
        slideUp(elm);
    })
    document.querySelector(".cart-summary").style.display = 'none';
    document.querySelector(".needs-calculation").style.display = 'block';
}

function removeItem(e) {
    e.preventDefault();
    let field = getParent(e.target, '.lineitem-container').querySelector('input.eventgallery-quantity');
    field.value = 0;
    field.form.submit();
}

/**
 * sets the quantity to 0 and submits the form.
 */
function removeAllItems(e) {

    e.preventDefault();
    let response = confirm(window.EventGalleryCartConfiguration?.removeAllItemsWarning);
    if (response === false) {
        return;
    }
    forEach(document.querySelectorAll('input.eventgallery-quantity'), (elm) => {
        elm.value = 0;
    })

    let form = getParent(e.target, 'form');
    form.submit();
}

document.addEventListener('DOMContentLoaded', () => {
    forEach(document.querySelectorAll('.scalepriceinformation'), (elm) => {
        elm.addEventListener('click', function(e) {
            e.preventDefault();
            let elm = getParent(e.target, 'div').querySelector('div.scaleprices');
            slideToggle(elm);
        });
    })

    forEach(document.querySelectorAll(".lineitem-container input"), (elm) => elm.addEventListener('change', setQuantityNeedsCalculationMode));
    forEach(document.querySelectorAll(".lineitem-container select"), (elm) => elm.addEventListener('change', (e) => {
        e.target.form.submit()
    }));
    forEach(document.querySelectorAll(".lineitem-container .delete-lineitem"), (elm) => elm.addEventListener('click', removeItem));
    forEach(document.querySelectorAll(".eventgallery-removeAll"), (elm) => elm.addEventListener('click', removeAllItems));

    forEach(document.querySelectorAll(".lineitem-container .add-comment"), (elm) => elm.addEventListener('click', (e) => {
        e.preventDefault();
        let textareaContainer = getParent(e.target, '.information').querySelector('.lineitem-comment');
        if (textareaContainer) {
            textareaContainer.classList.toggle("lineitem-comment-hidden")
        }
    }));

});


